import { withCompInfo } from '@wix/editor-elements-integrations'
import type { CompInfo } from '@wix/thunderbolt-becky-root'
import { SectionCss } from './Section'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import { getShapeDividersCSSVars } from '../../core/carmi/ShapeDividers/ShapeDividers.mapper'
import { getCompDesignPerVariant } from '../../core/carmi/ShapeDividers/ShapeDividers.utils'

const getShouldUseCssPerVariantMapper = (experiments: CompInfo['experiments']) =>
	experiments['specs.thunderbolt.responsiveShapeDividers'] ||
	experiments['specs.thunderbolt.responsiveShapeDividersPublic']

export const css = withCompInfo<SectionCss, any>()(
	[
		'compId',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'hasResponsiveLayout',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		compId,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		hasResponsiveLayout,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const compDesignPerVariantMap = getCompDesignPerVariant(compDesign)
		const defaultDesign = compDesignPerVariantMap[''] || {}
		const backgroundMedia = defaultDesign.background

		const fillLayersCSSVars = backgroundMedia
			? getFillLayersCSSVars({
					animations,
					backgroundMedia,
					compDesign,
					compProps,
					compId,
					experiments,
					isMobileView,
					isNonAdaptiveMobile,
					siteColors,
					viewMode,
			  })
			: {}

		const shouldUseCssMapper = !getShouldUseCssPerVariantMapper(experiments)
		const shapeDividersCSSVars = shouldUseCssMapper
			? getShapeDividersCSSVars({ compId, hasResponsiveLayout, isMobileView, compDesign })
			: {}

		return {
			...fillLayersCSSVars,
			...shapeDividersCSSVars,
		} as SectionCss
	}
)
